module.exports = __webpack_public_path__ + "img/thomas-kusiek-fm.2c3f58cf.jpg";